// @flow
export { default } from './PartnerComment';



// WEBPACK FOOTER //
// ./src/components/partner/PartnerComment/index.js